var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWallet3D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 44,
    viewBox: "0 0 135 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_313_17239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.143311,
    width: 127,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_313_17239)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1.14331,
    width: 125,
    height: 30,
    rx: 15,
    stroke: "#81C30D",
    strokeOpacity: 0.66,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8992 7.60913H21.0682C17.6522 7.60913 15.9442 7.60913 14.883 8.68038C13.8218 9.75164 13.8218 11.4758 13.8218 14.9241V17.3624C13.8218 20.8107 13.8218 22.5349 14.883 23.6061C15.9442 24.6774 17.6522 24.6774 21.0682 24.6774H25.8992C29.3152 24.6774 31.0232 24.6774 32.0844 23.6061C33.1456 22.5349 33.1456 20.8107 33.1456 17.3624V14.9241C33.1456 11.4758 33.1456 9.75164 32.0844 8.68038C31.0232 7.60913 29.3152 7.60913 25.8992 7.60913Z",
    stroke: "#192504",
    strokeWidth: 2.14709
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.116 11.8762H21.3366",
    stroke: "#192504",
    strokeWidth: 2.14709,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.012 20.4102H28.8378C27.8388 20.4102 27.3393 20.4102 27.0262 20.1032L27.0112 20.0882C26.7042 19.7751 26.7042 19.2756 26.7042 18.2766C26.7042 17.2777 26.7042 16.7782 27.0112 16.4651L27.0262 16.45C27.3393 16.1431 27.8388 16.1431 28.8378 16.1431H31.012C32.0109 16.1431 32.5104 16.1431 32.8235 16.45L32.8386 16.4651C33.1455 16.7782 33.1455 17.2777 33.1455 18.2766C33.1455 19.2756 33.1455 19.7751 32.8386 20.0882L32.8235 20.1032C32.5104 20.4102 32.0109 20.4102 31.012 20.4102Z",
    stroke: "#192504",
    strokeWidth: 2.14709
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1718 21.6433L44.3982 10.3511H47.4632L50.6734 21.6433H48.8828L48.1407 18.9816H43.7206L42.9786 21.6433H41.1718ZM44.1562 17.3684H47.7051L46.0597 11.432H45.8016L44.1562 17.3684ZM55.5425 21.8692C54.8865 21.8692 54.2789 21.7078 53.7196 21.3852C53.1604 21.0626 52.7087 20.6001 52.3646 19.9979C52.0312 19.3849 51.8645 18.6482 51.8645 17.7878V17.5459C51.8645 16.6963 52.0312 15.965 52.3646 15.352C52.6979 14.7389 53.1443 14.2711 53.7035 13.9485C54.2627 13.6259 54.8757 13.4645 55.5425 13.4645C56.0587 13.4645 56.4889 13.5291 56.833 13.6581C57.1879 13.7872 57.4783 13.9539 57.7041 14.1582C57.93 14.3518 58.1021 14.5561 58.2204 14.7712H58.4785V10.3511H60.14V21.6433H58.5107V20.5141H58.2526C58.0483 20.8582 57.7364 21.1701 57.317 21.4497C56.9083 21.7293 56.3168 21.8692 55.5425 21.8692ZM56.0103 20.4173C56.7309 20.4173 57.3224 20.1861 57.7848 19.7236C58.258 19.2612 58.4946 18.5998 58.4946 17.7394V17.5943C58.4946 16.7447 58.2634 16.0886 57.8009 15.6262C57.3385 15.1637 56.7416 14.9325 56.0103 14.9325C55.3005 14.9325 54.709 15.1637 54.2358 15.6262C53.7734 16.0886 53.5422 16.7447 53.5422 17.5943V17.7394C53.5422 18.5998 53.7734 19.2612 54.2358 19.7236C54.709 20.1861 55.3005 20.4173 56.0103 20.4173ZM65.8769 21.8692C65.2208 21.8692 64.6132 21.7078 64.054 21.3852C63.4948 21.0626 63.0431 20.6001 62.6989 19.9979C62.3655 19.3849 62.1988 18.6482 62.1988 17.7878V17.5459C62.1988 16.6963 62.3655 15.965 62.6989 15.352C63.0323 14.7389 63.4786 14.2711 64.0379 13.9485C64.5971 13.6259 65.2101 13.4645 65.8769 13.4645C66.3931 13.4645 66.8233 13.5291 67.1674 13.6581C67.5223 13.7872 67.8127 13.9539 68.0385 14.1582C68.2644 14.3518 68.4364 14.5561 68.5547 14.7712H68.8128V10.3511H70.4744V21.6433H68.8451V20.5141H68.587C68.3827 20.8582 68.0708 21.1701 67.6513 21.4497C67.2427 21.7293 66.6512 21.8692 65.8769 21.8692ZM66.3447 20.4173C67.0652 20.4173 67.6567 20.1861 68.1192 19.7236C68.5924 19.2612 68.829 18.5998 68.829 17.7394V17.5943C68.829 16.7447 68.5977 16.0886 68.1353 15.6262C67.6729 15.1637 67.076 14.9325 66.3447 14.9325C65.6349 14.9325 65.0434 15.1637 64.5702 15.6262C64.1078 16.0886 63.8765 16.7447 63.8765 17.5943V17.7394C63.8765 18.5998 64.1078 19.2612 64.5702 19.7236C65.0434 20.1861 65.6349 20.4173 66.3447 20.4173ZM77.8897 21.6433L76.2281 10.3511H77.9703L79.3254 20.4657H79.5835L81.3257 10.3511H84.3746L86.1168 20.4657H86.3749L87.7139 10.3511H89.4561L87.7945 21.6433H84.7456L82.9712 11.3836H82.7131L80.9547 21.6433H77.8897ZM93.5682 21.8692C92.9982 21.8692 92.4873 21.7724 92.0357 21.5788C91.5947 21.3852 91.2398 21.1002 90.971 20.7238C90.7129 20.3474 90.5838 19.8903 90.5838 19.3526C90.5838 18.8041 90.7129 18.3524 90.971 17.9975C91.2398 17.6319 91.6001 17.3577 92.0518 17.1748C92.5142 16.992 93.0358 16.9006 93.6166 16.9006H96.0363V16.3844C96.0363 15.9219 95.8965 15.5509 95.6169 15.2713C95.3373 14.9917 94.9071 14.8519 94.3264 14.8519C93.7564 14.8519 93.3208 14.9863 93.0197 15.2552C92.7186 15.524 92.5196 15.8735 92.4228 16.3037L90.8742 15.8036C91.0032 15.3735 91.2076 14.9863 91.4872 14.6422C91.7775 14.2873 92.1593 14.0023 92.6325 13.7872C93.1057 13.5721 93.6757 13.4645 94.3425 13.4645C95.3749 13.4645 96.1869 13.728 96.7784 14.255C97.3699 14.782 97.6656 15.5294 97.6656 16.4973V19.772C97.6656 20.0947 97.8162 20.256 98.1173 20.256H98.7948V21.6433H97.5527C97.1763 21.6433 96.8698 21.5465 96.6332 21.3529C96.3966 21.1594 96.2783 20.8959 96.2783 20.5625V20.5141H96.0363C95.9503 20.6754 95.8212 20.8636 95.6492 21.0787C95.4771 21.2938 95.2244 21.482 94.891 21.6433C94.5576 21.7939 94.1166 21.8692 93.5682 21.8692ZM93.8101 20.498C94.4769 20.498 95.0146 20.3098 95.4233 19.9334C95.832 19.5462 96.0363 19.0192 96.0363 18.3524V18.1911H93.7133C93.2724 18.1911 92.9175 18.2879 92.6487 18.4815C92.3798 18.6643 92.2454 18.9386 92.2454 19.3042C92.2454 19.6699 92.3852 19.9602 92.6648 20.1753C92.9444 20.3904 93.3262 20.498 93.8101 20.498ZM100.41 21.6433V10.3511H102.072V21.6433H100.41ZM104.538 21.6433V10.3511H106.199V21.6433H104.538ZM112.311 21.8692C111.504 21.8692 110.8 21.7025 110.198 21.3691C109.596 21.0249 109.122 20.5464 108.778 19.9334C108.445 19.3096 108.278 18.589 108.278 17.7717V17.5781C108.278 16.75 108.445 16.0295 108.778 15.4165C109.112 14.7927 109.574 14.3141 110.166 13.9808C110.768 13.6366 111.461 13.4645 112.247 13.4645C113.01 13.4645 113.677 13.6366 114.247 13.9808C114.828 14.3141 115.279 14.782 115.602 15.3842C115.925 15.9865 116.086 16.6909 116.086 17.4975V18.1266H109.972C109.993 18.8256 110.225 19.3849 110.666 19.8043C111.117 20.213 111.677 20.4173 112.343 20.4173C112.967 20.4173 113.435 20.2775 113.747 19.9979C114.069 19.7183 114.317 19.3956 114.489 19.03L115.86 19.7398C115.709 20.0409 115.489 20.3582 115.199 20.6915C114.919 21.0249 114.548 21.3045 114.086 21.5304C113.623 21.7562 113.032 21.8692 112.311 21.8692ZM109.988 16.8522H114.392C114.349 16.2499 114.134 15.7821 113.747 15.4487C113.36 15.1046 112.854 14.9325 112.23 14.9325C111.607 14.9325 111.096 15.1046 110.698 15.4487C110.311 15.7821 110.074 16.2499 109.988 16.8522ZM120.787 21.6433C120.303 21.6433 119.916 21.4981 119.625 21.2078C119.346 20.9174 119.206 20.5302 119.206 20.0463V15.0938H117.012V13.6904H119.206V11.0609H120.867V13.6904H123.239V15.0938H120.867V19.7559C120.867 20.0785 121.018 20.2399 121.319 20.2399H122.981V21.6433H120.787Z",
    fill: "#0B0E21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_313_17239",
    x: 0.773663,
    y: -1.85669,
    width: 133.453,
    height: 45.2263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.22634,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_313_17239"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.22634
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_313_17239"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247917 0 0 0 0 0.495833 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_313_17239",
    result: "effect2_dropShadow_313_17239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_313_17239",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.403292,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_innerShadow_313_17239"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164174 0 0 0 0 0.391667 0 0 0 0 0.0571181 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_313_17239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_313_17239",
    x1: 67.5,
    y1: 0.143311,
    x2: 67.5,
    y2: 32.1433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84C70D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#659B06"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWallet3D);
export default __webpack_public_path__ + "static/media/add-wallet-3D.f3ce87c32dab36e9cc507dcf48f11b76.svg";
export { ForwardRef as ReactComponent };